import useLazyFetchSearchFiltersByNlp from '@th/frontend-shared/src/hooks/queries/useLazyFetchSearchFiltersByNlp';
import { useMap } from '../contexts/MapContext';
import { useSearch } from '../contexts/SearchContext';

export default function useFetchNlpSearchAndApplyFilters(): [
  (nlpPhrase: string) => void,
  { isLoading: boolean },
] {
  const {
    resetAndUpdateFiltersOnTopOfExistingCoreValues,
    openNlpSearchStatusModalToLoading,
    closeNlpSearchModal,
  } = useSearch();
  const [fetchSearchFiltersByNlp, { isLoading }] =
    useLazyFetchSearchFiltersByNlp();
  const { clearAreaOverlay } = useMap();

  async function fetchSearchFiltersByNlpAndApplyFilters(searchPhrase: string) {
    openNlpSearchStatusModalToLoading(searchPhrase);

    const searchFilters = await fetchSearchFiltersByNlp(searchPhrase);
    closeNlpSearchModal();

    clearAreaOverlay();
    resetAndUpdateFiltersOnTopOfExistingCoreValues(searchFilters);
    closeNlpSearchModal();
  }

  return [fetchSearchFiltersByNlpAndApplyFilters, { isLoading }];
}
